import { Compound } from '../../services/restserver-openapi';

export type AgentLabel = {
    labelId: number;
    labelName: string;
    logo?: string | null;
    compoundIds: number[];
}

const getAuthHeaders = () => {
    const token = sessionStorage.getItem('token');

    return {
        'Content-Type': 'application/json',
        ...(token ? { authorization: `Bearer ${token}` } : {}),
    };
};

const getApiUrl = (path: string) => `${process.env.REACT_APP_API_URL ?? ''}${path}`;

async function parseJsonResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }

    return response.json();
}

export async function getLabels(): Promise<AgentLabel[]> {
    const response = await fetch(getApiUrl('/labels'), {
        headers: getAuthHeaders(),
    });

    return parseJsonResponse<AgentLabel[]>(response);
}

export async function getLabelsByCompoundId(compoundId: number): Promise<AgentLabel[]> {
    const response = await fetch(getApiUrl(`/compounds/${compoundId}/labels`), {
        headers: getAuthHeaders(),
    });

    return parseJsonResponse<AgentLabel[]>(response);
}

export async function createLabel(label: AgentLabel): Promise<AgentLabel> {
    const response = await fetch(getApiUrl('/labels'), {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(label),
    });

    return parseJsonResponse<AgentLabel>(response);
}

export async function updateLabel(label: AgentLabel): Promise<AgentLabel> {
    const response = await fetch(getApiUrl(`/labels/${label.labelId}`), {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(label),
    });

    return parseJsonResponse<AgentLabel>(response);
}

export async function deleteLabel(labelId: number): Promise<void> {
    const response = await fetch(getApiUrl(`/labels/${labelId}`), {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Delete failed with status ${response.status}`);
    }
}

export async function addCompoundToLabel(labelId: number, compoundId: number): Promise<AgentLabel> {
    const response = await fetch(getApiUrl(`/labels/${labelId}/compounds/${compoundId}`), {
        method: 'PUT',
        headers: getAuthHeaders(),
    });

    return parseJsonResponse<AgentLabel>(response);
}

export async function removeCompoundFromLabel(labelId: number, compoundId: number): Promise<AgentLabel> {
    const response = await fetch(getApiUrl(`/labels/${labelId}/compounds/${compoundId}`), {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });

    return parseJsonResponse<AgentLabel>(response);
}

export function getCompoundLabel(compound: Compound): string {
    return `${compound.name} (#${compound.compoundId})`;
}
